<template>
  <div class="soundkit-header tw-grid tw-items-start" :class="{'soundkit-header--has-video': hasVideo}">
    <!-- Artwork -->
    <div class="soundkit-header__artwork tw-rounded tw-overflow-hidden tw-self-start">
      <BaseArtwork :src="soundkit.image(600)"
                   :image-size="600"
                   @click="isPlaying ? soundkit.pause() : soundkit.play()"
                   :active="isActive">
        <BasePlay slot="center"
                  :playing="isPlaying" />
      </BaseArtwork>
    </div>

    <!-- Details -->
    <div class="soundkit-header__details">
      <!-- Title -->
      <div class="tw-text-3xl tw-font-medium tw-text-infinity-primary-text tw-flex tw-items-center tw-mb-5">
        <span>{{ soundkit.name }}</span>
        <share-button :item="soundkit" class="tw-text-infinity-tertiary-text tw-ml-4" style="font-size: 1.15rem;" />
      </div>

      <!-- Description -->
      <SoundkitHeaderDescription :text="soundkit.description" class="tw-pb-6" />
    </div>

    <!-- Chips -->
    <div class="soundkit-header__chips tw-grid tw-gap-4">
      <SoundkitHeaderChips v-if="soundkit.tags.length" icon="hashtag" label="Tags" :chips="soundkit.tagsFormatted" />
      <SoundkitHeaderChips v-if="soundkit.instruments.length" icon="drum" label="Instruments"
                           :chips="soundkit.instruments" />
      <SoundkitHeaderChips v-if="soundkit.soundTypes.length" icon="waveform-path" label="Sound Types"
                           :chips="soundkit.soundTypes" />
    </div>
    <!-- Feature disabled -->
    <!--    <div class="soundkit-header__video tw-relative tw-inline-block tw-self-start tw-cursor-pointer"
         style="max-width: 135px;"
         @click="playYouTubeVideo"
         v-if="hasVideo">
      <img class="tw-rounded" :src="soundkit.youtubeThumbnailLink" width="100%" alt="Sound Pack Youtube Preview">
      <div class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center">
        <font-awesome-icon class="tw-text-3xl tw-text-white tw-shadow" :icon="['fab', 'youtube']" />
      </div>
    </div>-->
  </div>
</template>
<script>
import BaseArtwork from "../../base/base-artwork";
import BasePlay from "../../base/base-play";
import SoundKit from "../../../models/soundkit";
import ShareButton from "../../shared/share-button";
import SoundkitHeaderChips from "./soundkit-header-chips";
import SoundkitHeaderDescription from "./soundkit-header-description";

export default {
  components: { SoundkitHeaderDescription, SoundkitHeaderChips, ShareButton, BasePlay, BaseArtwork },
  props: {
    soundkit: {
      type: SoundKit
    }
  },
  computed: {
    playerActive() {
      return this.$store.state.player.playing;
    },
    playlistManager() {
      return this.$store.state.playlistManager;
    },
    isPlaying() {
      return (this.playlistManager.isPlaying(this.soundkit) && this.playerActive);
    },
    isPaused() {
      return (this.playlistManager.isPlaying(this.soundkit) && !this.playerActive);
    },
    isActive() {
      return this.isPlaying || this.isPaused;
    },
    hasVideo() {
      // feature disabled
        // return !!this.soundkit.youtubeEmbedLink;
      return false
    }
  },
  methods: {
    playYouTubeVideo() {
      this.$modal.show("youtube-video", { url: this.soundkit.youtubeEmbedLink });
    }
  }
};
</script>
<style lang="scss" scoped>
.soundkit-header {
  @apply tw-gap-7;
  grid-template-columns: 1fr;
  grid-template-areas: 'artwork' 'details' 'chips';

  &--has-video {
    grid-template-areas: 'artwork' 'video' 'details' 'chips';
  }

  &__artwork {
    grid-area: artwork;
  }

  &__details {
    grid-area: details;
  }

  &__chips {
    grid-area: chips;
  }

  &__video {
    grid-area: video;
  }

  @screen sm {
    grid-template-columns: minmax(30%, 200px) 1fr;
    grid-template-areas: 'artwork details' 'chips chips';
    &--has-video {
      grid-template-areas: 'artwork details' 'video video' 'chips chips';
    }
  }

  @screen md {
    grid-template-areas: 'artwork details' 'artwork chips';
    &--has-video {
      grid-template-areas: 'artwork details' 'artwork chips' 'video chips';
    }
  }

  @screen lg {
    grid-template-columns: minmax(40%, 370px) 1fr;
  }
}
</style>
